/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordEmailAddressFieldComponent } from '../../admin/form/form-record/fields/emailaddress/form-record-emailaddress-field.component';
/* eslint-enable */

export class FormRecordEmailAddressFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordEmailAddressFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
